import { AppConstants } from '../shared/app.constants';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { environment } from '../../environments/environment';
var SmsBlastService = /** @class */ (function () {
    function SmsBlastService(appConstants, http, auth) {
        this.appConstants = appConstants;
        this.http = http;
        this.auth = auth;
    }
    SmsBlastService.prototype.sendSMS = function (body) {
        var url = environment.apiBase + 'sms/blast';
        var headers = this.auth.getAuthorizationHeaders();
        headers = headers.delete('Accept');
        return this.http.post(url, body, { headers: headers, responseType: 'text' })
            .map(function (res) { return res; })
            .catch(this.appConstants.errorHandler);
    };
    return SmsBlastService;
}());
export { SmsBlastService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/sms-blast/sms-blast.service.ts.pre-build-optimizer.js